import { ArrowLeft } from 'lucide-react';
import { cn } from '../lib/utils';

/**
 * The round back button before a record's title. 40px, the same size as the
 * menu button, so the two line up on phones and tablets (see .title-row).
 */
export function BackButton({ onClick, label, className, ...props }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      title={label}
      className={cn('flex items-center justify-center w-10 h-10 shrink-0 rounded-full bg-mist hover:bg-parchment transition-colors', className)}
      {...props}
    >
      <ArrowLeft className="w-[18px] h-[18px]" />
    </button>
  );
}
